var map = {
	"./active-btn.webp": 2524,
	"./angbao-bonus-thaipusam.webp": 2525,
	"./angbao-bonus.webp": 2526,
	"./angbao-bonus_dewali.webp": 2527,
	"./cny-lucky-draw.webp": 2528,
	"./cny-promo.webp": 2529,
	"./dewali-promo.webp": 2530,
	"./fifa-prediction.webp": 2531,
	"./fifa-qna.webp": 2532,
	"./raya-promo.webp": 2533,
	"./welcome-cny-bonus.webp": 2534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2523;